import { useRouter } from 'next/router'
import useSWR, { KeyedMutator } from 'swr'
import { NotFound } from 'shared/errors/not-found'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import useUser, { isAuthorizedUser } from 'shared/hooks/use-user'

export interface IsMemberResponse {
  id: number
  userId: number
}

interface UseIsUserMemberResult {
  member: IsMemberResponse | undefined
  isUserMember: boolean | undefined
  isLoading: boolean
  mutate: KeyedMutator<IsMemberResponse>
}

export default function useIsUserMember(
  path?: string,
  notFoundResponseHandler: (error: NotFound) => void = () => {},
  shouldRetryOnError?: boolean,
): UseIsUserMemberResult {
  const router = useRouter()
  const { user } = useUser()
  const { communityPath } = router.query

  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, IsMemberResponse>({
    method: RequestMethodsEnum.get,
    notFoundResponseHandler,
  })

  const {
    isValidating: isLoading,
    data: member,
    mutate,
  } = useSWR(
    () => {
      if (user && isAuthorizedUser(user) && (communityPath || path)) {
        return `/api/community/community/${communityPath || path}/member`
      }
    },
    fetcher,
    { shouldRetryOnError },
  )

  return {
    member,
    isUserMember: member !== undefined ? !!member : undefined,
    isLoading,
    mutate,
  }
}
